import script from "./Transactions.vue?vue&type=script&setup=true&lang=ts"
export * from "./Transactions.vue?vue&type=script&setup=true&lang=ts"

import "./Transactions.vue?vue&type=style&index=0&id=403a68a4&scoped=true&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-403a68a4"]])

export default __exports__